export default __webpack_public_path__ + "static/media/barbershop.02c63327.png";